import { DeepPartial } from "setup/deepPartial";

import { EventTemplateFormValues } from "./types";

export const EVENT_INIT_VALUES: DeepPartial<EventTemplateFormValues> = {
  input: {},
};

export const RECURRING_EVENT_TAB_NAMES = {
  details: "details",
  tickets: "tickets",
  codes: "discount",
  events: "events",
};
